import { User, UserList } from 'src/components/models/User'

export const BusinessStore = {
  namespaced: true,
  state: {
    lastSavedPage: null,
    scrollPosition: null,
    users: [],
    lists: [],
    count: null,
    importer: {
      businessId: '',
      file: null,
      headers: [],
      listId: '',
      listName: '',
      importerSelection: '',
      newList: '',
      persons: [],
      step: 1
    },
    selectedBusinessHeaders: [],
    allBusinessHeaders: [],
    personalizedTags: [],
    personalizedExtradata: [],
    orderedExtradata: [],
    orderedTags: []
  },
  mutations: {
    SET_USERS (state, users: User[]) {
      state.users = users
    },
    SET_USERS_COUNT (state, count) {
      state.count = count
    },
    SET_USERS_LISTS (state, lists: UserList[]) {
      state.lists = lists
    },
    SET_SELECTED_HEADERS (state, headers) {
      state.selectedBusinessHeaders = headers
    },
    SET_HEADERS (state, headers) {
      state.allBusinessHeaders = headers
    },
    SET_PERSONALIZED_EXTRADATA (state, personalizedExtradata) {
      state.personalizedExtradata = personalizedExtradata
    },
    SET_PERSONALIZED_TAGS (state, personalizedTags) {
      state.personalizedTags = personalizedTags
    },
    SET_ORDERED_EXTRADATA (state, ordered) {
      state.orderedExtradata = ordered
    },
    SET_ORDERED_TAGS (state, ordered) {
      state.orderedTags = ordered
    },
    SET_LAST_PAGE (state, lastPage) {
      state.lastSavedPage = lastPage
    },
    SET_SCROLL_POSITION (state, position) {
      state.scrollPosition = position
    }
  },
  actions: {
  }
}
